module.exports = __webpack_public_path__ + "media/images/flags/cl-d047975de88c64a494fa72ccdc858802.svg";